/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface EditTeamNoteRequest
 */
export interface EditTeamNoteRequest {
  /**
   *
   * @type {string}
   * @memberof EditTeamNoteRequest
   */
  noteId: string;
  /**
   *
   * @type {string}
   * @memberof EditTeamNoteRequest
   */
  body: string;
}

/**
 * Check if a given object implements the EditTeamNoteRequest interface.
 */
export function instanceOfEditTeamNoteRequest(
  value: object,
): value is EditTeamNoteRequest {
  if (!("noteId" in value) || value["noteId"] === undefined) return false;
  if (!("body" in value) || value["body"] === undefined) return false;
  return true;
}

export function EditTeamNoteRequestFromJSON(json: any): EditTeamNoteRequest {
  return EditTeamNoteRequestFromJSONTyped(json, false);
}

export function EditTeamNoteRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EditTeamNoteRequest {
  if (json == null) {
    return json;
  }
  return {
    noteId: json["noteId"],
    body: json["body"],
  };
}

export function EditTeamNoteRequestToJSON(json: any): EditTeamNoteRequest {
  return EditTeamNoteRequestToJSONTyped(json, false);
}

export function EditTeamNoteRequestToJSONTyped(
  value?: EditTeamNoteRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    noteId: value["noteId"],
    body: value["body"],
  };
}
